define(['jquery',
        'core/urls',
        'core/workflow-steps',
        'core/loading-animation',
        'core/logo-picker',
        'clipboard-polyfill',
        'core/uploader',
        'core/logo-repository',
        'core/browser-storage',
        "components/modal",
        'bootstrap-toggle',
],
function($, 
    urls, 
    workflow_steps, 
    loading_animation, 
    logo_picker, 
    clipboard_polyfill, 
    uploader, 
    logo_repository,
    storage,
    modal,
) {
        let nodes = {
            logoPicker: document.querySelector(".logo-picker_js"),
            modalUploadLogoContent: document.querySelector('.modal-template-upload_js'),
            progress: document.querySelector(".marketing-loader"),
            getLogosContainer: function () {
                return document.querySelector(".modal-template-upload_js .logos_js")
            },
            imgPreview: {
                withLogo: document.querySelector(".conf-mail-withlogo_js"),
                noLogo: document.querySelector(".conf-mail-nologo_js"),
                controls: document.querySelector(".conf-mail-upload-ctrl_js"),
                openBtn: document.querySelector(".uploader-open_js"),
                minusLogo: document.querySelector(".uploader-delete-logo_js")
            },
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".configuration-survey"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ],
            },
        }

        let createdModal = modal.create(nodes.modal, function (el) {});

        let logoFrame = {
            onSelected: function() {
                $('#continue-btn-logo').removeClass('btn-link').addClass('button-primary').text($('#continue-btn-logo').data('textWithLogo'));
            },
            onCleared: function() {
                $('#continue-btn-logo').removeClass('button-primary').addClass('btn-link').text($('#continue-btn-logo').data('textWithoutLogo'));
            }
        };

        let _generateSnippet = (params) => {
            $.get(urls[window.SNIPPET_GENERATION_URL](), $.extend({}, params, {testMode: true}))
                .done(function(snippet) {
                    $('#email-snippet').html(snippet);
                });
            $.get(urls[window.SNIPPET_GENERATION_URL](), $.extend({}, params, {testMode: false}))
                .done(function(snippet) {
                    $('#js-survey-snippet').val(snippet);
                });
        }

        let hidePreviewTabs = () => {
            var MIN_WIDTH = 768;

            function getOrientation() {
                return Math.abs(window.orientation) - 90 == 0 ? 'portrait' : 'landscape';
            }
            function getMobileWidth() {
                return getOrientation() == 'landscape' ? screen.availWidth : screen.availHeight;
            }

            return getMobileWidth() < MIN_WIDTH;
        }

        function onFileUploadFailed(error, fileInfo) {
            if (error && error == 'image') {
                $('#uploaderAlert').text('The uploaded file does not appear to a valid image file.').collapse('show');
            } else if (error && error == 'fileMaximumSize') {
                $('#uploaderAlert').text('The maximum size of images is ' + window.UPLOADCARE_FILE_MAX_MB + ' MiB.').collapse('show');
            } else if (error && error == 'fileType') {
                $('#uploaderAlert').text('The file type isn\'t allowed').collapse('show');
            } else {
                $('#uploaderAlert').text('Generic error').collapse('show');
            }
        }

        let progress = (function () {
            let p = nodes.progress;
            p.classList.add("disabled");
            return {
                start: function () {
                    p.classList.remove("disabled");
                },
                stop: function () {
                    p.classList.add("disabled");
                }
            }
        })();

        let addImgToList = (wrap, imageData) => {
            let div = document.createElement("div");
            div.style.backgroundImage = "url('" + imageData.src + "')";
    
            ['id', "title", "src"].forEach(function (key) {
                div.setAttribute("data-" + key, imageData[key]);
            });
    
            div.classList.add("sb-modal-upload__select-item");
            div.classList.add("logo-item_js");
    
            div.setAttribute("alt", imageData.title);
            wrap.prepend(div);
        }

        let imageWorker = {
            set: function (img) {
                this.image = img
            },
            save: function () {
                storage.addObj("conf-email-img", this.image || {id: "", title: "", src: ""});
            },
            get: function () {
                return this.image
            },
            remove: function () {
                storage.removeItem("conf-email-img");
            }
        };
    
        let waitImg = (src, onLoaded) => {
            var preloaderImg = document.createElement("img");
            preloaderImg.src = src;
            preloaderImg.addEventListener('load', (event) => {
                preloaderImg = null;
                onLoaded();
            });
        }
    
        let addImgToPreview = (imageContainer, img) => {
            setImgId(img.id);
            imageContainer.withLogo.style.backgroundImage = 'url(' + img.src + ')';
            imageContainer.withLogo.setAttribute('alt', img.name);
            ['id', "uuid"].forEach(function (key) {
                imageContainer.withLogo.setAttribute('data' + key, img[key]);
            });
            logoFrame.onSelected();
        }
    
        let setImgId = (id) => {
            document.querySelector("#logo_id").value = id;
        }
    
        let removeImgId = () => {
            document.querySelector("#logo_id").value = "";
            imageWorker.remove();
        }
    
        let showPreview = (nodes) => {
            nodes.controls.classList.remove("disabled");
            nodes.noLogo.classList.add("disabled");
            nodes.withLogo.classList.remove("disabled");
        }
    
        let hidePreview = (nodes) => {
            removeImgId();
            nodes.controls.classList.add("disabled");
            nodes.noLogo.classList.remove("disabled");
            nodes.withLogo.classList.add("disabled");
        }
    
        let setImg = (image) => {
            imageWorker.set(image);
            addImgToPreview(nodes.imgPreview, image);
            if (image.id)
                showPreview(nodes.imgPreview, image);
        }

        let openUploadModal = (uploadcare) => {
            createdModal.open(null, function (el) {
                let btn = el.querySelector(".upload-care_js");
    
                btn.addEventListener("click", function () {
                    let dialog = uploadcare.openDialog(null, {
                        validators: [
                            uploader.maxSizeValidator(window.UPLOADCARE_FILE_MAX_MB * 1024 * 1024),
                            uploader.fileTypeValidator('png jpeg jpg gif')
                        ]
                    });
    
                    dialog.done(function imageUploaded(file) {
    
                        createdModal.close();
                        progress.start();

                        file.always((data) => {
                            if(!data.isImage) {
                                uploadError(data);
                            }
                        })
    
                        file.done(function (fileInfo) {
                            logo_repository
                                .LogoRepository
                                .save(fileInfo.uuid)
                                .done(function (logo) 
                            {
                                let img = {
                                    title: logo.title,
                                    id: logo.id,
                                    src: logo.resource_thumbnail,
                                };
    
                                imageWorker.set(img);
                                addImgToList(nodes.getLogosContainer(), img);
                                addImgToPreview(nodes.imgPreview, img);
                                waitImg(logo.resource_thumbnail, function () {
                                    showPreview(nodes.imgPreview);
                                    progress.stop();
                                })
                            });
                        });
    
                    }).fail(function (data) {
                        onFileUploadFailed();
                        nodes.imgPreview.noLogo.classList.remove("disabled");
                        progress.stop();
                    });
    
                });
    
                var logosWrapper = el.querySelector(".logos_js");
    
                function onLogoClick(e) {
    
                    var image = {};
                    var target = e.target;
                    var id = target.getAttribute("data-id");
    
                    if (!id) {
                        return
                    }
    
                    image.id = id;
                    image.src = target.getAttribute("data-src");
                    image.title = target.getAttribute("data-title");
    
                    addImgToPreview(nodes.imgPreview, image);
    
                    imageWorker.set(image);
    
                    showPreview(nodes.imgPreview);
    
                    createdModal.close(function () {
                        logosWrapper.removeEventListener("click", onLogoClick);
                    });
    
                }
    
                let showMoreButton = el.querySelector(".show-more_js");
                function showAllLogos() {
                    let hiddenLogos = el.querySelectorAll(".logo-item_js.hide-mobile");
                    hiddenLogos.forEach(logo => {
                        logo.classList.remove("hide-mobile");
                    });
                    showMoreButton.innerText = "Close"
                    showMoreButton.removeEventListener("click", showAllLogos);
                    showMoreButton.addEventListener("click", () => createdModal.close());
                }
    
                logosWrapper.addEventListener("click", onLogoClick);
                el.querySelector(".modal-close_js").addEventListener("click", () => {
                    createdModal.close();
                });
                showMoreButton.addEventListener("click", showAllLogos);
    
            }, nodes.modalUploadLogoContent)
    
        }

        let uploadError = () => {
            let errorElement = document.querySelector(".logo-error");
            errorElement.classList.remove("hide");
            setTimeout(() => {
                errorElement.classList.add("hide");
            }, 5000)
            progress.stop();
        }

        let uploaderCallback = (uploadcare) => {
            nodes.logoPicker.addEventListener("dragover", function (e) {
                nodes.logoPicker.classList.add("dragover");
            });
    
            nodes.logoPicker.addEventListener("click", function (e) {
                openUploadModal(uploadcare);
            });
    
            nodes.logoPicker.addEventListener("dragleave", function (e) {
                nodes.logoPicker.classList.remove("dragover");
            });
    
            uploadcare.dragdrop.uploadDrop(nodes.logoPicker, function (file) {
    
                nodes.logoPicker.classList.remove("dragover");
                progress.start();

                file.always((data) => {
                    if(!data.isImage) {
                        uploadError(data);
                    }
                })
    
                file.done(function (params) {
                    if (params.isImage) {
                        logo_repository
                        .LogoRepository
                        .save(params.uuid)
                        .done(function (logo) {
                            var img = {
                                title: logo.title,
                                id: logo.id,
                                src: logo.resource_thumbnail,
                            };
    
                            imageWorker.set(img);
                            addImgToList(nodes.getLogosContainer(), img);
                            addImgToPreview(nodes.imgPreview, img);
                            waitImg(logo.resource_thumbnail, function () {
                                showPreview(nodes.imgPreview);
                                progress.stop();
                            })
                        });
                    }
                });
            });
    
            let image = storage.getObj("conf-email-img");
    
            if (nodes.selectedImg) {
                image = nodes.selectedImg.getAttribute("value");
                image = JSON.parse(image);
                setImg(image);
            }
    
            nodes.imgPreview.minusLogo.addEventListener("click", function () {
                hidePreview(nodes.imgPreview);
            });
    
            nodes.imgPreview.openBtn.addEventListener('click', function () {
                openUploadModal(uploadcare);
            });
    
            progress.stop();
        }

        return {
            init: function() {
                uploader.initializeAndWaitUntilReady(
                    function(uploadcare){
                        uploaderCallback(uploadcare)
                    }
                );

                loading_animation.start();
                $('#button-start-configurator').click(function() {
                    $(this).parent().hide();
                    $('#survey-configurator').slideDown();
                });

                if (hidePreviewTabs()) {
                    $('#preview .nav-pills').remove();
                    $('#email').remove();
                    $('#submission').remove();
                    $('#post-submission').remove();
                    $('#preview .alert.small-screen').removeClass('collapse');
                    $('#code-snippet').addClass('active');
                }

                $('#preview').on('show.bs.modal', function (e) {
                    params = {
                        logo: document.querySelector("#logo_id").value || 0,
                        lang: $('#snippet-language-selector').val(),
                        publication: $('#id_ask_for_publication').prop('checked'),
                        labels: $('#id_add_labels').prop('checked'),
                        google_review_url: $('#id_ask_for_google_review').prop('checked')?$('#id_google_link').val().trim():'',
                    };
                    _generateSnippet(params);
                    $(this).find('a[href="#code-snippet"]').tab('show'); // open "Email Snippet" tab if it exists
                    $('#preview-submission').attr('src', urls['configuration:survey-preview']('submission') + '?' + $.param(params));
                    $('#preview-post-submission').attr('src', urls['configuration:survey-preview']('post-submission') + '?' + $.param(params));
                });

                var clickId = 'js-survey-copysnippet';
                var snippetId = 'js-survey-snippet';
                $('#'+clickId).on('click', function(e) {
                    e.preventDefault();
                    var snippet = $('#'+snippetId).val();

                    var dt = new clipboard_polyfill.DT();
                    dt.setData('text/plain', snippet);
                    dt.setData('text/html', snippet.replace(/<a href=/g, '\n<a href=').replace(/<img/g, '\n<img'));
                    clipboard_polyfill.write(dt);
                    var message = '<i class="glyphicons glyphicons-ok"></i> Copied!';
                    var currentTitle = $(this).html();
                    var currentWidth = $(this).css('width');
                    $(this).css('min-width', currentWidth);
                    $(this).html(message);
                    setTimeout(function() {
                        $(this).html(currentTitle);
                        $(this).css('min-width', 'auto');
                    }.bind(this), 1500);

                    $('#alertHasGeneratedSnippet').collapse('show');

                    return false;
                });

                var steps = $('#survey-configurator-steps').workflowSteps({
                    steps: ['#step-1', '#step-2', '#step-3']
                });

                $('#preview').on('hide.bs.modal', function (e) {
                    steps.onBack();
                });

                $('#id_ask_for_google_review').change(function () {
                    if($(this).prop('checked')){
                        document.querySelector('#id_google_link').disabled = false;
                    } else {
                        document.querySelector('#id_google_link').disabled = true;
                    }
                });

                $('.snippet-options-container').submit(function (e) {
                    event.preventDefault();
                    if(e.target.checkValidity()) {
                        steps.successfulStep(1);
                        steps.activateStep(2);
                        steps.scrollTo(3);
                    }
                });
                loading_animation.complete();
            }
        };
    }
);
